import React from 'react';
import PropTypes from 'prop-types';
import './style.scss'
import { IncludActiveMembersText, IncludInActiveMembersText } from 'admin/views/multi-access';
import { DifferentAccessItems, AllAccessItem, ItemWrapper } from './modules';
// import Icon from 'common/components/elements/icons';

const MultiAccessItem = ({
   type,
   className,
   openEditModal,
   moreState,
   mode,
   different,
   all,
   onChangeAccessMode,
   contentType,
   statistics,
   isMobile,
   cancelChackbox,
   showPrerelease,
   showDownload,
   videoType,
   showNewStyles,
   globalDisabled,
   globalDisabledTooltipText,
}) => {
   let isActiveMember = 'active' === type
   let isCheckdDifferent = 'different' === mode
   const {
      activeMemberCount,
      expiredMemberCount,
      guestMemberCount,
      cancelledMemberCount,
      freeMemberCount,
      subscribedMemberCount,
   } = statistics;

   const getOthersLabel = () => {
      let sufix = '';
      switch (contentType) {
         case 'chat':
         case 'store':
         case 'live_stream_chat':{
            sufix = ''
            break;
         }
         case 'mass_message':{
            sufix = ' / Subscribers'
            break;
         }
         default:{
            sufix = ' / Visitors'
            break;
         }
      }
      return `Expired members <br> Guests${ sufix }`
   }


   return (
      <div className={ `flex flex-col w-full ${ className } multiple-access-item-content` }>
         {type === 'active' && contentType === 'custom_page' && (
            <div className='mb-4'>
               <span className='leading-tight text-major font-bold'>Who can view this page?</span>
            </div>
         )}
         <div className='flex items-center mb-1'>
            <span className={ 'leading-tight text-major font-semibold select-none' }>{isActiveMember ? 'Members' : 'Others'} </span>
         </div>
         {
            isActiveMember && (
               <IncludActiveMembersText
                  showNewStyles={ contentType === 'mass_message' || showNewStyles }
                  activeMemberCount={ activeMemberCount }
                  cancelledMemberCount={ cancelledMemberCount }
                  freeMemberCount={ freeMemberCount }
               />
            )
         }
         {
            !isActiveMember && (
               <IncludInActiveMembersText
                  showNewStyles={ contentType === 'mass_message' || showNewStyles }
                  expiredMemberCount={ expiredMemberCount }
                  guestMemberCount={ guestMemberCount }
                  subscribedMemberCount={ subscribedMemberCount }
                  isVisitor={  !['mass_message', 'live_stream_chat', 'chat', 'store', 'poll'].includes(contentType) }
               />
            )
         }
         <ItemWrapper
            radioLableProps={
               {
                  id: `${ type }_all`,
                  checked: !isCheckdDifferent,
                  onChange: () => onChangeAccessMode('all'),
                  disabled: globalDisabled,
                  radioButtonTooltipText: globalDisabledTooltipText,
               }
            }
            contentType={ contentType }
            title={ isActiveMember ? 'Same settings for all memberships' : 'Same settings for all others' }
         >
            {
               !isCheckdDifferent && (
                  <AllAccessItem
                     all={ all }
                     moreState={ moreState }
                     contentType={ contentType }
                     isMobile={ isMobile }
                     showPrerelease={ showPrerelease }
                     showDownload={ showDownload }
                     videoType={ videoType }
                     openEditModal={ openEditModal }
                     isActiveMember={ isActiveMember }
                     getOthersLabel={ getOthersLabel }
                     globalDisabled={ globalDisabled }
                     globalDisabledTooltipText={ globalDisabledTooltipText }
                  />
               )
            }
         </ItemWrapper>
         <ItemWrapper
            radioLableProps={
               {
                  id: `${ type }_different`,
                  checked: isCheckdDifferent,
                  onChange: () => onChangeAccessMode('different'),
                  disabled: globalDisabled,
                  radioButtonTooltipText: globalDisabledTooltipText,
               }
            }
            contentType={ contentType }
            title={ isActiveMember ? 'Different settings for each membership' : 'Different settings for each type' }
            className='mt-3'
         >
            {
               isCheckdDifferent && (
                  <DifferentAccessItems
                     different={ different }
                     // cancelChackbox={ cancelChackbox }
                     moreState={ moreState }
                     contentType={ contentType }
                     isMobile={ isMobile }
                     showPrerelease={ showPrerelease }
                     showDownload={ showDownload }
                     videoType={ videoType }
                     openEditModal={ openEditModal }
                     globalDisabled={ globalDisabled }
                     globalDisabledTooltipText={ globalDisabledTooltipText }
                  />
               )
            }
         </ItemWrapper>
      </div>
   )
}


MultiAccessItem.propTypes = {
   type: PropTypes.oneOf(['active', 'public']),
   className: PropTypes.string,
   openEditModal: PropTypes.func,
   moreState: PropTypes.object,
   all: PropTypes.object,
   different: PropTypes.array,
   onChangeAccessMode: PropTypes.func,
   mode: PropTypes.PropTypes.oneOf(['all', 'different']),
   contentType: PropTypes.string,
   statistics: PropTypes.object,
   isMobile: PropTypes.bool,
   cancelChackbox: PropTypes.bool,
   showPrerelease: PropTypes.bool,
   showDownload: PropTypes.bool,
   videoType: PropTypes.string,
   showNewStyles: PropTypes.bool,
   globalDisabled: PropTypes.bool,
   globalDisabledTooltipText: PropTypes.string,
};
MultiAccessItem.defaultProps = {
   className: '',
   type: 'active',
   contentType: 'chat',
   onChangeAccessMode: () => {},
   showNewStyles: false,
};

export default MultiAccessItem
